export function progressBar(container, scrollCallback = null) {
  const inner = container.querySelector(".inner");
  const list = inner.querySelector(".list");
  const progressBarContainer = container.querySelector(
    ".progress-bar-container"
  );
  const progressBar = container.querySelector(".progress-bar");

  let dragStat = new Proxy(
    {
      active: false,
    },
    {
      set(target, property, value) {
        if (property === "active") {
          if (value) {
            container.classList.add("scroll-draggable");
          } else {
            setTimeout(() => {
              container.classList.remove("scroll-draggable");
            }, 500);
          }
        }
        return Reflect.set(...arguments);
      },
    }
  );
  let currentY;
  let initialY;
  let top = 0;

  const event = new Event("scroll");

  const update = () => {
    inner.dispatchEvent(event);
    dragStat.active = false;
  };

  const scroll = () => {
    const viewportRatio = container.clientHeight / inner.scrollHeight;
    let height = 0;
    let realHeight = 0;

    let diffHeight = 0;

    if (viewportRatio < 1) {
      realHeight = Math.floor(container.clientHeight * viewportRatio);
      height = Math.max(50, realHeight);
      if (height > realHeight) {
        diffHeight = height - realHeight;
      }
    }

    if (top > diffHeight) {
      top -= diffHeight;
    }

    var currY = $(inner).scrollTop();
    var postHeight = $(inner).height();
    var scrollHeight = $(list).height();
    var scrollPercent = currY / (scrollHeight - postHeight);

    progressBar.style.height = `${height}px`;
    progressBar.style.top = `${top}px`;
    progressBar.style.opacity = 1;

    if (scrollCallback) {
      scrollCallback(scrollPercent);
    }
  };

  inner.addEventListener("scroll", (e) => {
    e.preventDefault();
    e.stopPropagation();

    top =
      (((inner.scrollTop * 100) / inner.scrollHeight) *
        progressBarContainer.clientHeight) /
      100;

    scroll();
  });

  $(inner).on("mousewheel DOMMouseScroll", function (e) {
    var scrollTo = null;

    if (e.type === "mousewheel") {
      scrollTo = e.originalEvent.wheelDelta * -1;
    } else if (e.type === "DOMMouseScroll") {
      scrollTo = 40 * e.originalEvent.detail;
    }

    if (scrollTo) {
      e.preventDefault();
      $(this).scrollTop(scrollTo + $(this).scrollTop());
    }
  });

  const dragStart = (e) => {
    if (e.type === "touchstart") {
      initialY = e.touches[0].clientY - top;
    } else {
      initialY = e.clientY - top;
    }

    if (e.target === progressBar) {
      dragStat.active = true;
    }
  };
  const dragEnd = (e) => {
    dragStat.active = false;
  };
  const drag = (e) => {
    if (dragStat.active) {
      e.preventDefault();

      if (e.type === "touchmove") {
        currentY = e.touches[0].clientY - initialY;
      } else {
        currentY = e.clientY - initialY;
      }

      $(inner).scrollTop(
        (currentY * inner.scrollHeight) / container.clientHeight
      );
    }
  };

  container.addEventListener("touchstart", dragStart, false);
  container.addEventListener("touchend", dragEnd, false);
  container.addEventListener("touchmove", drag, false);

  container.addEventListener("mousedown", dragStart, false);
  container.addEventListener("mouseup", dragEnd, false);
  container.addEventListener("mousemove", drag, false);

  window.addEventListener("click", function (e) {
    if (!(progressBar === e.target || progressBar.contains(e.target))) {
      dragStat.active = false;
    }
  });

  update();

  return update;
}
